import { routeNaming } from '../../routes';
import { Home } from '../../pages/home';
import { NotFound } from '../../pages/not-found';
import { GoToNotFound } from '../../pages/go-to-not-found';
import { ProductDetail } from '../../pages/product-detail';
import { ProductIndex } from '../../pages/product-index';
import { ProductGroup } from '../../pages/product-group';
import { Search } from '../../pages/search';
import { Compare } from '../../pages/compare';
import { MyData } from '../../pages/my-account/my-data';
import { MyCredit } from '../../pages/my-account/my-credit';
import { MyOrders } from '../../pages/my-account/my-orders';
import { MyPhoneNumbers } from '../../pages/my-account/my-phone-numbers';
import { Cart } from '../../pages/cart';
import { MyBillingData } from '../../pages/my-account/my-billing-data';
import { PaymentMethodsAndBilling } from '../../pages/payment-methods-and-billing';
import { MyAddresses } from '../../pages/my-account/my-addresses';
import { MyFavorites } from '../../pages/my-account/my-favorites';

const routeConfig = [
  {
    name: routeNaming.HOME,
    component: Home,
  },
  {
    name: routeNaming.NOT_FOUND,
    component: NotFound,
  },
  {
    name: routeNaming.PRODUCT_DETAIL,
    component: ProductDetail,
  },
  {
    name: routeNaming.PRODUCT_INDEX,
    component: ProductIndex,
  },
  {
    name: routeNaming.PRODUCT_GROUP,
    component: ProductGroup,
  },
  {
    name: routeNaming.SEARCH_RESULTS,
    component: Search,
  },
  {
    name: routeNaming.COMPARE,
    component: Compare,
  },
  {
    name: routeNaming.GO_TO_NOT_FOUND,
    component: GoToNotFound,
  },
  {
    name: routeNaming.MY_DATA,
    component: MyData,
  },
  {
    name: routeNaming.MY_FAVORITES,
    component: MyFavorites,
  },
  {
    name: routeNaming.MY_CREDITS,
    component: MyCredit,
  },
  {
    name: routeNaming.MY_ORDERS,
    component: MyOrders,
  },
  {
    name: routeNaming.MY_PHONE_NUMBERS,
    component: MyPhoneNumbers,
  },
  {
    name: routeNaming.CART,
    component: Cart,
  },
  {
    name: routeNaming.MY_BILLING_DATA,
    component: MyBillingData,
  },
  {
    name: routeNaming.PAYMENT_METHODS_AND_BILLING,
    component: PaymentMethodsAndBilling,
  },
  {
    name: routeNaming.MY_ADDRESSES,
    component: MyAddresses,
  },
];

export { routeConfig };



// WEBPACK FOOTER //
// ./src/apps/home/routes.js